import React, {Component} from 'react'

import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'

import SemaphoreLight from "./SemaphoreLight"

import PaperBlock from "../../ui/PaperBlock"

import BoxImage from "./BoxImage.png"
import BoxImage_Done from "./BoxImage_Done.png"

import {
	Button,
} from '@material-ui/core'

/**
 * <ShowsList shows selected onClickShow = {show} />
 */

class ShowsList extends Component {

	formatShowTime(date) {
		let t = (date.split(" ")[1]).split(":")
		return `${t[0]}:${t[1]}`
	}

	formatShowDate(date) {
		const monthNames = [
			"января",
			"февраля",
			"марта",
			"апреля",
			"мая",
			"июня",
			"июля",
			"августа",
			"сентября",
			"октября",
			"ноября",
			"декабря",
		]
		let spDate = (date.split(" ")[0]).split("-")
		let monthName = monthNames[parseInt(spDate[1]) - 1]
		return `${spDate[2]} ${monthName}`
	}

	getShowArtistsString(show) {
		switch (show.artists.length) {
			case 0:
				return "не указан"
			case 1:
				return show.artists[0].name
			default:
				return show.artists.map(artist => artist.name).join(", ")
		}
	}

	render() {

		return <PaperBlock>

			<List>

				{this.props.shows.map((show, n) => {
					return <ListItem
						key={n}
						button
						selected={this.props.selected ? this.props.selected.id === show.id : false}
						onClick={e => {
							e.stopPropagation()
							if (typeof this.props.onClickShow === "function") {
								this.props.onClickShow(show)
							}
						} }
					>

						<div
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexDirection: "column",
								marginLeft: "0px",
								marginRight: "10px",
							}}
						>

							{/*
<div>
<Tooltip title = "Коробка большая">
<Typography variant='h5'>{show.boxBig}</Typography>
</Tooltip>
</div>
*/}

							{/* Иконка коробки */}

							<div>
								<img src={show.completed === 0 ? BoxImage : BoxImage_Done} width={32} alt="show" />
							</div>


							{/* Светофор */}

							<div style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
								flexDirection: "column",
							}}>

								<div
									style={{
										display: "flex",
									}}
								>

									<Tooltip title={show.issuance.complete ? "Выдача завершена" : "Выдача не завершена"}>
										<div><SemaphoreLight color={show.issuance.color} /></div>
									</Tooltip>

									<Tooltip title={show.reception.complete ? "Прием завершен" : "Прием не завершен"}>
										<div><SemaphoreLight color={show.reception.color} /></div>
									</Tooltip>

								</div>

							</div>

						</div>

						{/* Описание шоу */}

						<div style={{
							display: "flex",
							width: "100%",
							alignItems: 'center',
						}}>
							<div
								style={{
									flex: "auto",
								}}
							>
								<Typography variant='h5'>{show.name}</Typography>
								<Typography variant='subtitle2'>Ведущий: {this.getShowArtistsString(show)}</Typography>
								{/* <Typography variant='subtitle2'>Коробка большая: {show.boxBig}</Typography> */}
								<Typography variant='subtitle2'>Код коробки: {show.box.code} </Typography>
								<Typography variant='subtitle2'>Адрес: {show.address}</Typography>
								{/* <Typography variant='subtitle2'>Коробка большая: {show.boxBig}, Коробка средняя: {show.boxMedium}</Typography> */}
							</div>

							{/* Третья колонка, дата и завершение */}

							<div
								style={{
									marginRight: 'auto',
									display: 'flex',
									flexDirection: 'column',
								}}
							>

								<Tooltip title={show.date}>

									<div
										style={{
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
										}}
									>

										<Typography style={{
											alignSelf: "center",
											whiteSpace: "nowrap",
										}}>
											{this.formatShowDate(show.date)}
										</Typography>

										<Typography style={{ alignSelf: "center" }}>
											{this.formatShowTime(show.date)}
										</Typography>

									</div>

								</Tooltip>

								{/* Кнопка быстрого завершения */}

								<Button
									style={{ marginTop: '10px', padding: "2px 8px" }}
									variant="contained"
									onClick={e => {
										e.stopPropagation()
										if (typeof this.props.onCloseShow === "function") {
											this.props.onCloseShow(show)
										}
									} }
									onDoubleClick={e => e.stopPropagation()}
								>{show.completed === 1 ? "Возобновить" : "Завершить"}</Button>

							</div>

						</div>

					</ListItem>
				})}

			</List>

		</PaperBlock>

	}

}

export default ShowsList
